/**
 * Application Configuration
 *
 * This file contains configuration constants used across the application.
 * Note: Client IDs are NOT secrets - they are meant to be public identifiers.
 * Never store client secrets in frontend code.
 */

export default {
  strava: {
    clientId: '45744',
    authUrl: 'https://www.strava.com/oauth/mobile/authorize',
    scopes: {
      read: 'read,activity:read',
      write: 'read,activity:read,activity:write'
    }
  },

  // Helper method to generate redirect URI
  getRedirectUri () {
    return window.location.origin + '/webhook?client=strava'
  },

  // Helper method to generate Strava OAuth URL
  getStravaAuthUrl (scope = 'write') {
    const selectedScope = this.strava.scopes[scope] || this.strava.scopes.write
    const redirectUri = this.getRedirectUri()

    return `${this.strava.authUrl}?client_id=${this.strava.clientId}&response_type=code&approval_prompt=force&scope=${selectedScope}&redirect_uri=${encodeURIComponent(redirectUri)}`
  }
}
